import {NgModule} from '@angular/core';

import {ContentTypeBadgeComponent} from './index';
import {IonicModule} from 'ionic-angular';

/**
 * Module for the content type badge
 */
@NgModule({
  declarations: [ContentTypeBadgeComponent],
  exports: [ContentTypeBadgeComponent],
  imports: [
    IonicModule,
  ],
  providers: [],
})
export class ContentTypeBadgeModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/content-type-badge/content-type-badge.module.ts